var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "phone_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6FB265",
    d: "M16.625 17.5q-2.604 0-5.146-1.135t-4.625-3.22-3.219-4.624T2.5 3.375q0-.375.25-.625a.85.85 0 0 1 .625-.25H6.75q.292 0 .52.198a.76.76 0 0 1 .272.469l.541 2.916q.042.334-.02.563a.9.9 0 0 1-.23.396l-2.02 2.041q.415.77.99 1.49.572.719 1.26 1.385.645.645 1.354 1.198.708.552 1.5 1.01l1.958-1.958q.187-.187.49-.28.302-.094.593-.053l2.875.583a.97.97 0 0 1 .48.302.73.73 0 0 1 .187.49v3.375q0 .375-.25.625a.85.85 0 0 1-.625.25M5.021 7.5l1.375-1.375-.354-1.958H4.188q.104.855.291 1.687.188.833.542 1.646m7.458 7.458a10.4 10.4 0 0 0 3.354.834v-1.834l-1.958-.396z"
  }))));
};
export default SvgPhone;